const DROPDOWN_VIEWPORT_GUTTER = 16;

export const getDropdownMenuWidth = (fieldElement) => {
  const fieldWidth = fieldElement?.getBoundingClientRect().width;

  if (!fieldWidth) {
    return undefined;
  }

  const availableViewportWidth =
    typeof window === 'undefined'
      ? fieldWidth
      : Math.max(0, window.innerWidth - DROPDOWN_VIEWPORT_GUTTER * 2);

  return Math.round(Math.min(fieldWidth, availableViewportWidth));
};

export const getDropdownMenuWidthStyles = (menuWidth) => ({
  boxSizing: 'border-box',
  ...(menuWidth
    ? {
        width: menuWidth,
        minWidth: menuWidth,
        maxWidth: menuWidth,
      }
    : {}),
});

export const getDropdownSearchPlaceholder = (searchFieldPlaceholderText, placeHolderText) => {
  const placeholder = String(searchFieldPlaceholderText || placeHolderText || '').trim();

  if (!placeholder) return 'Search';

  return /^search(?:\s|$)/i.test(placeholder) ? placeholder : `Search ${placeholder}`;
};
